module.exports = __webpack_public_path__ + "img/1_2024_08_23.08798854.png";